"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulk_upload.button': '批量上传',
    'knowledge.bulk_upload.title': '批量上传知识文件',
    'knowledge.bulk_upload.description': '上传多个文件以自动创建知识条目',
    'knowledge.bulk_upload.files': '选择文件',
    'knowledge.bulk_upload.files_placeholder': '点击选择文件或拖拽多个文件到此处',
    'knowledge.bulk_upload.files_help': '支持的格式：PDF、DOC、DOCX、TXT、MD、HTML、RTF、CSS、SCSS、JS/TS + 存档文件（ZIP、TAR等）',
    'knowledge.bulk_upload.archive_support': '存档文件（ZIP、TAR等）将自动解压缩并处理文档文件',
    'knowledge.bulk_upload.project_help': '选择一个项目来组织上传的知识文件',
    'knowledge.bulk_upload.upload': '上传文件',
    'knowledge.bulk_upload.uploading': '上传中...',
    'knowledge.bulk_upload.processing': '处理文件中...',
    'knowledge.bulk_upload.info.title': '上传信息',
    'knowledge.bulk_upload.info.title_from_filename': '文件名将用作知识条目标题（不包含扩展名）',
    'knowledge.bulk_upload.info.description_auto': '描述将根据文件名自动生成',
    'knowledge.bulk_upload.info.project_optional': '项目分配是可选的',
    'knowledge.bulk_upload.info.tags_shared': '标签将应用于所有上传的文件',
    'knowledge.bulk_upload.info.rag_auto_index': '文件将自动在RAG系统中建立索引',
    'knowledge.bulk_upload.info.archive_extraction': '存档文件将被解压缩，其中的文档文件将自动处理',
    'knowledge.bulk_upload.tags_help': '这些标签将应用于所有上传的知识文件',
    'knowledge.bulk_upload.upload_mode': '上传模式',
    'knowledge.bulk_upload.mode.files': '上传文件',
    'knowledge.bulk_upload.mode.google_drive_directory': 'Google Drive 目录',
    'knowledge.bulk_upload.google_drive_not_connected': 'Google Drive 未连接。请先在设置中连接。',
    'knowledge.bulk_upload.google_drive_setup_required': '在设置中连接 Google Drive 以使用此功能。',
    'knowledge.bulk_upload.google_drive_directory': 'Google Drive 目录',
    'knowledge.bulk_upload.google_drive_directory_help': '选择一个 Google Drive 目录，从其中所有文件创建知识条目',
    'knowledge.bulk_upload.selected_directory': '已选择目录',
    'knowledge.bulk_upload.google_drive_select_directory': '从 Google Drive 选择目录',
    'knowledge.bulk_upload.google_drive_process': '处理目录',
    'knowledge.bulk_upload.google_drive_processing': '正在处理 Google Drive 目录...',
    'knowledge.bulk_upload.info.google_drive.all_files': '目录中的所有文件将被处理',
    'knowledge.bulk_upload.info.google_drive.content_fetch': '内容将从 Google Drive 获取',
    'knowledge.bulk_upload.info.google_drive.project_required': '项目分配是必需的',
    'knowledge.bulk_upload.info.google_drive.file_support': '支持：文档、PDF、文本文件等',
};
